import script from "./SignupProgressModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupProgressModal.vue?vue&type=script&setup=true&lang=ts"

import "./SignupProgressModal.vue?vue&type=style&index=0&id=36d72fd9&scoped=true&lang=scss"

import exportComponent from "../../../../../home/franc/adereso-bsp-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d72fd9"]])

export default __exports__